import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type LayoutState } from './layout.types';

import { FocusElement } from '~/core/enums';

const initialState: LayoutState = {
  focusElement: undefined,
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,

  reducers: {
    updateFocusElement: (
      state: LayoutState,
      action: PayloadAction<FocusElement>
    ) => {
      state.focusElement = action.payload;
    },
    resetFocusElement: (state: LayoutState) => {
      state.focusElement = initialState.focusElement;
    },
    toggleFocusElement: (
      state: LayoutState,
      action: PayloadAction<FocusElement>
    ) => {
      state.focusElement =
        state.focusElement === action.payload ? undefined : action.payload;
    },
  },
});

export const { updateFocusElement, resetFocusElement, toggleFocusElement } =
  layoutSlice.actions;

export default layoutSlice.reducer;
